import { colors } from '../../colors';
var promoBanner = {
  bgColor: colors.lightPink,
  fontColor: colors.lead,
  textColorDark: colors.lead,
  textColorLight: colors.white
};
export default promoBanner;